<div class="kendo-surface-grid" [class.grid-pagination-off]="!paginationEnabled()">
  <kendo-grid
    #grid
    [kendoGridBinding]="usingSignals ? newMappedSignals() : records"
    filterable="menu"
    [sortable]="true"
    [columnMenu]="menuSettings"
    [style.height.%]="100"
    [pageable]="pagerSettings()"
    [rowClass]="updateRowColor"
    [groupable]="true"
    [isGroupExpanded]="isGroupExpanded"

    [skip]="gridSkip()"
    [pageSize]="gridPageSize()"
    [sort]="gridState().sort ?? []"
    [group]="gridState().group ?? []"
    [filter]="gridState().filter ?? { logic: 'and', filters: [] }"

    (dataStateChange)="onDataStateChange($event)"
    (filterChange)="onFilterChange($event)"
    (sortChange)="onSortChange($event)"
    (pageChange)="onPageChange($event)"
    (groupChange)="onGroupChange($event)"
    (groupExpand)="onGroupExpand($event)"
    (groupCollapse)="onGroupCollapse($event)"
    (cellClick)="onCellClick($event)"
    (columnVisibilityChange)="onGridColumnsChanged()"
    [reorderable]="true"
  >
    <ng-template #columnMenuContent let-service="service" let-menuColumn="column">
      <div class="cm-modal-body">
        <!-- 1. SORT SECTION -->
        <div class="cm-card">
          <div class="cm-card-header">
            <ion-icon name="swap-vertical-outline" class="cm-card-icon"></ion-icon>
            <span class="cm-card-title">Sorting</span>
            <span class="cm-card-badge" *ngIf="getColumnSortDir($any(menuColumn)?.field) as sortDir">
              {{ sortDir === 'asc' ? 'Ascending' : 'Descending' }}
            </span>
          </div>
          <div class="cm-btn-row">
            <button
              type="button"
              class="cm-pill-btn"
              [class.cm-pill-btn--active]="getColumnSortDir($any(menuColumn)?.field) === 'asc'"
              (click)="setColumnSort($any(menuColumn)?.field, 'asc', service)"
            >
              <ion-icon name="arrow-up-outline"></ion-icon>
              <span>Ascending</span>
            </button>
            <button
              type="button"
              class="cm-pill-btn"
              [class.cm-pill-btn--active]="getColumnSortDir($any(menuColumn)?.field) === 'desc'"
              (click)="setColumnSort($any(menuColumn)?.field, 'desc', service)"
            >
              <ion-icon name="arrow-down-outline"></ion-icon>
              <span>Descending</span>
            </button>
            <button
              type="button"
              class="cm-pill-btn cm-pill-btn--clear"
              [disabled]="!getColumnSortDir($any(menuColumn)?.field)"
              (click)="setColumnSort($any(menuColumn)?.field, 'clear', service)"
            >
              <ion-icon name="close-circle-outline"></ion-icon>
              <span>Clear</span>
            </button>
          </div>
        </div>

        <!-- 2. FILTER SECTION -->
        <div class="cm-card">
          <div class="cm-card-header">
            <ion-icon name="filter-outline" class="cm-card-icon"></ion-icon>
            <span class="cm-card-title">Filter Column</span>
            <span class="cm-card-badge cm-card-badge--active" *ngIf="hasColumnFilter($any(menuColumn)?.field)">
              Filtered
            </span>
          </div>
          <div class="cm-filter-container">
            <kendo-grid-columnmenu-filter [service]="service" [expanded]="true"></kendo-grid-columnmenu-filter>
          </div>
          <div class="cm-filter-foot-actions" *ngIf="hasAnyFilters()">
            <button
              type="button"
              class="cm-action-link cm-action-link--danger"
              (click)="clearAllFilters(service)"
            >
              <ion-icon name="close-circle-outline"></ion-icon>
              <span>Clear all Grid Filters</span>
            </button>
          </div>
        </div>

        <!-- 3. COLUMN SIZING SECTION -->
        <div class="cm-card">
          <div class="cm-card-header">
            <ion-icon name="resize-outline" class="cm-card-icon"></ion-icon>
            <span class="cm-card-title">Column Sizing</span>
          </div>
          <div class="cm-btn-row">
            <button
              type="button"
              class="cm-pill-btn"
              (click)="adjustColumnWidth('smaller', $any(menuColumn)?.field, service)"
              title="Make column narrower"
            >
              <ion-icon name="remove-outline"></ion-icon>
              <span>Narrower</span>
            </button>
            <button
              type="button"
              class="cm-pill-btn"
              (click)="resetColumnWidth($any(menuColumn)?.field, service)"
              title="Reset to default width"
            >
              <ion-icon name="refresh-outline"></ion-icon>
              <span>Reset</span>
            </button>
            <button
              type="button"
              class="cm-pill-btn"
              (click)="adjustColumnWidth('bigger', $any(menuColumn)?.field, service)"
              title="Make column wider"
            >
              <ion-icon name="add-outline"></ion-icon>
              <span>Wider</span>
            </button>
          </div>
          <div class="cm-btn-row cm-btn-row--secondary">
            <button
              type="button"
              class="cm-pill-btn"
              (click)="autoFitCurrentColumn(menuColumn, service)"
              title="Autosize this column to fit content"
            >
              <ion-icon name="expand-outline"></ion-icon>
              <span>Fit Column</span>
            </button>
            <button
              type="button"
              class="cm-pill-btn"
              (click)="autoFitAllGridColumns(service)"
              title="Autosize all columns"
            >
              <ion-icon name="contract-outline"></ion-icon>
              <span>Fit All Columns</span>
            </button>
          </div>
        </div>

        <!-- 4. POSITION & CHOOSER SECTION -->
        <div
          class="cm-card"
          *ngIf="menuSettings.setColumnPosition || menuSettings.columnChooser !== false"
        >
          <div class="cm-card-header">
            <ion-icon name="pin-outline" class="cm-card-icon"></ion-icon>
            <span class="cm-card-title">Columns & Position</span>
          </div>
          <div class="cm-column-position-container">
            <kendo-grid-columnmenu-position
              *ngIf="menuSettings.setColumnPosition"
              [service]="service"
              [showLock]="$any(menuSettings)?.lock ?? false"
              [showStick]="$any(menuSettings)?.stick ?? false"
              [expanded]="false"
            >
            </kendo-grid-columnmenu-position>

            <kendo-grid-columnmenu-chooser [service]="service" [expanded]="false"></kendo-grid-columnmenu-chooser>
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template kendoGridColumnMenuTemplate let-service="service" let-menuColumn="column">
      <ng-container *ngIf="captureAndOpenColumnMenuModal(service, menuColumn)"></ng-container>
    </ng-template>

    <ng-template kendoGridToolbarTemplate>
      <div class="grid-toolbar-row">
        <div class="grid-toolbar-left">
          <button kendoGridExcelCommand [svgIcon]="fileExcelIcon">Excel</button>
          <button kendoGridPDFCommand [svgIcon]="filePdfIcon">PDF</button>
          <button
            type="button"
            class="grid-toolbar-button grid-toolbar-copy-button"
            aria-label="Copy grid data"
            title="Copy grid data"
            (click)="copyGridToClipboard()"
          >
            <ion-icon name="copy-outline" aria-hidden="true"></ion-icon>
            <span>Copy</span>
          </button>
          <button
            *ngIf="hasGrouping()"
            type="button"
            class="grid-toolbar-button"
            (click)="toggleAllGroups()"
          >
            {{ allGroupsToggleLabel() }}
          </button>
          <label class="grid-toolbar-toggle">
            <input
              type="checkbox"
              [checked]="paginationEnabled()"
              (click)="$event.stopPropagation()"
              (change)="togglePagination($any($event.target).checked)"
            />
            Pagination
          </label>
          <label class="grid-toolbar-page-size">
            <span>Rows</span>
            <select
              [value]="selectedPageSizeValue()"
              [disabled]="!paginationEnabled()"
              (click)="$event.stopPropagation()"
              (mousedown)="$event.stopPropagation()"
              (change)="onPageSizeSelection($event)"
            >
              @for (item of pageSizeItems; track item.value) {
                <option [value]="item.value">{{ item.text }}</option>
              }
            </select>
          </label>
        </div>
        <ng-container *ngIf="filterIndicator() as fi">
          <div class="grid-toolbar-right" *ngIf="fi.total > 0">
            <button
              type="button"
              class="grid-filter-indicator"
              [class.has-hidden]="fi.hidden > 0"
              [class.has-missing]="fi.missing > 0"
              (click)="openFilters($event)"
            >
              Filters: {{ fi.total }}
              <span *ngIf="fi.hidden > 0 || fi.missing > 0">
                (
                <ng-container *ngIf="fi.hidden > 0">{{ fi.hidden }} hidden</ng-container>
                <ng-container *ngIf="fi.hidden > 0 && fi.missing > 0">, </ng-container>
                <ng-container *ngIf="fi.missing > 0">{{ fi.missing }} missing</ng-container>
                )
              </span>
            </button>
          </div>
        </ng-container>
      </div>
    </ng-template>

    @for (column of effectiveColumns(); track column.field; let i = $index) {
      <kendo-grid-column
        [field]="column.field"
        [title]="column.title"
        [hidden]="column.hidden"
        [width]="column.width ? column.width : (column.field === 'EffectiveAlarmCategoryName' || column.display?.render?.type === 'categoryPill' || column.display?.render?.type === 'statusPill' ? 180 : 100)"
        [format]="column.format"
        [filter]="$any(column).filter ?? 'text'"
        [locked]="$any(column).locked ?? false"
        [sticky]="$any(column).sticky ?? false"
      >
        <ng-template kendoGridGroupHeaderTemplate let-group="group" let-value="value">
          {{ groupHeaderText(value, group) }}
        </ng-template>

        <ng-template *ngIf="column.display?.render?.type === 'statusPill' || column.display?.render?.type === 'categoryPill' || column.display?.render?.type === 'chip'" kendoGridCellTemplate let-dataItem>
          <ng-container *ngIf="statusPill(column, dataItem) as pill">
            <span
              class="status-pill"
              [ngClass]="pill.class"
              [style.backgroundColor]="pill.background"
              [style.color]="pill.color"
            >
              {{ pill.text }}
            </span>
          </ng-container>
        </ng-template>
        <ng-template *ngIf="column.type === 'date'" kendoGridCellTemplate let-dataItem>
          {{
            resolvePath(dataItem, column.field)
              ? (resolvePath(dataItem, column.field) | mobileTimezoneDate:gridDateFormat(column):resolveDateSiteId(dataItem))
              : ''
          }}
        </ng-template>
        <ng-template *ngIf="column.field === 'ShortTagName'" kendoGridCellTemplate let-dataItem>
          <div class="tag-row" (contextmenu)="onRightClick($event, dataItem)"
               (touchstart)="onTouchStart($event, dataItem)" (touchend)="onTouchEnd($event)">
            <span>{{ dataItem.ShortTagName }}</span>
            <ion-button
              *ngIf="shouldShowInvestigationAction(column, dataItem)"
              fill="clear"
              size="small"
              title="Configure playback investigation for alarm"
              aria-label="Configure playback investigation for alarm"
              data-trend-ignore="true"
              (click)="onInvestigationClick($event, dataItem)"
            >
              <ion-icon name="search-circle-outline"></ion-icon>
            </ion-button>
          </div>
        </ng-template>

        <ng-template
          kendoGridFilterMenuTemplate
          let-filter="filter"
          let-kendoColumn="column"
          let-filterService="filterService"
        >
          <ng-container *ngIf="column.display?.render?.type === 'statusPill' && column.field === 'Severity'; else advancedFilter">
            <div class="status-filter-menu">
              <div class="status-filter-header">
                <ion-icon name="filter-outline"></ion-icon>
                <label class="status-filter-label">Filter Status</label>
              </div>
              <div class="status-filter-controls">
                <select
                  class="status-filter-select"
                  [value]="statusPillFilterValue(filter, column.field)"
                  (change)="onStatusPillFilterChange($event, filter, column.field, filterService)"
                >
                  <option value="">All Statuses</option>
                  <option value="Normal">Normal</option>
                  <option value="Alarm">Alarm</option>
                  <option value="Critical">Critical</option>
                </select>
                <button
                  type="button"
                  class="status-filter-clear"
                  (click)="clearStatusPillFilter(filter, column.field, filterService)"
                >
                  Clear
                </button>
              </div>
            </div>
          </ng-container>
          <ng-template #advancedFilter>
            <lib-kendo-multi-filter-menu
              [column]="kendoColumn ?? column"
              [filter]="filter"
              [filterService]="filterService"
              (applyFilter)="onColumnMenuFilterApplied($event, (kendoColumn ?? column)?.field, filterService)"
              (clearFilter)="onColumnMenuFilterCleared((kendoColumn ?? column)?.field, filterService)"
            ></lib-kendo-multi-filter-menu>
          </ng-template>
        </ng-template>

        <ng-template *ngIf="['SiteName', 'Asset.ParentSystem.Name', 'Asset.Name'].includes(column.field)" kendoGridCellTemplate let-dataItem>
        <div style="display: flex; align-items: center; justify-content: space-between;">
          <span>{{ dataItem | path: column.field }}</span>
          <div style="display: flex; align-items: center;">
            <ion-button
              fill="clear"
              size="small"
              data-trend-ignore="true"
              (click)="onChevronClick($event, column.field, dataItem)"
            >
              <ion-icon name="chevron-forward-outline"></ion-icon>
            </ion-button>
          </div>
        </div>
      </ng-template>

      </kendo-grid-column>
    }

    <kendo-grid-excel [fetchData]="allData" fileName="TagExport.xlsx"></kendo-grid-excel>

    <kendo-grid-pdf fileName="TagExport.pdf" [allPages]="true" paperSize="A4" [repeatHeaders]="true" [landscape]="true">
      <kendo-grid-pdf-margin top="2cm" left="1cm" right="1cm" bottom="2cm" />
      <ng-template kendoGridPDFTemplate let-pageNum="pageNum" let-totalPages="totalPages">
        <div class="page-template">
          <div class="header">
            <div style="float: right">Page {{ pageNum }} of {{ totalPages }}</div>
            Tag Export - Historical Data
          </div>
          <div class="footer">Page {{ pageNum }} of {{ totalPages }}</div>
        </div>
      </ng-template>
    </kendo-grid-pdf>
  </kendo-grid>

  <ion-popover
    #filtersPopover
    [isOpen]="filtersModalOpen && usePopoverFilters"
    [event]="filtersEvent"
    [dismissOnSelect]="true"
    (didDismiss)="closeFilters(undefined, true)"
  >
    <ng-template>
      <ion-list lines="none">
        <ion-item>
          <ion-label>Filters</ion-label>
        </ion-item>

        @for (mi of filtersMenuItems(); track mi.id) {
          <ion-item
            button
            detail="false"
            [disabled]="mi.disabled"
            (click)="onFiltersMenuItemClick(mi, $event)"
          >
            <ion-icon *ngIf="mi.icon" slot="start" [name]="mi.icon"></ion-icon>
            <ion-label>{{ mi.text }}</ion-label>
          </ion-item>
        }
      </ion-list>
    </ng-template>
  </ion-popover>

  <ion-action-sheet
    [isOpen]="filtersModalOpen && !usePopoverFilters"
    [header]="'Filters'"
    [buttons]="filtersButtons"
    (didDismiss)="closeFilters(undefined, true)"
  ></ion-action-sheet>

  <ion-modal
    class="kendo-columnmenu-ion-modal"
    [isOpen]="columnMenuModalOpen"
    (didDismiss)="onColumnMenuModalDidDismiss()"
  >
    <ng-template>
      <ion-header translucent="true">
        <ion-toolbar class="cm-modal-toolbar">
          <div slot="start" class="cm-modal-title-wrap">
            <ion-icon name="funnel-outline" class="cm-modal-title-icon"></ion-icon>
            <ion-title class="cm-modal-title">{{ columnMenuModalTitle }}</ion-title>
          </div>
          <ion-buttons slot="end">
            <ion-button fill="clear" class="cm-modal-close-btn" (click)="requestCloseColumnMenuModal()">
              <ion-icon slot="icon-only" name="close"></ion-icon>
            </ion-button>
          </ion-buttons>
        </ion-toolbar>
      </ion-header>

      <ion-content class="ion-padding kendo-columnmenu-modal">
        <ng-container *ngIf="columnMenuModalService && columnMenuModalColumn">
          <ng-container
            *ngTemplateOutlet="columnMenuContent; context: { service: columnMenuModalService, column: columnMenuModalColumn }"
          ></ng-container>
        </ng-container>
      </ion-content>
    </ng-template>
  </ion-modal>
</div>
